module.exports = __webpack_public_path__ + "static/media/p3.43fed955.png";